import React, { useState, useEffect, useCallback, useRef } from 'react';
import './style.css';

/* ═══════════════════════════════════════════════════════════════
   API 엔드포인트 카테고리 정의
   ═══════════════════════════════════════════════════════════════ */
const API_CATEGORIES = [
  {
    id: 'home', label: '🏠 홈',
    apis: [
      { name: 'SelectNews', path: '/request/SelectNews', method: 'GET' },
      { name: 'SelectQA', path: '/request/SelectQA', method: 'GET' },
      { name: 'SelectFree', path: '/request/SelectFree', method: 'GET' },
      { name: 'GetFeedPhoto', path: '/request/GetFeedPhoto', method: 'GET' },
    ],
  },
  {
    id: 'board-free', label: '📋 게시판 — 자유',
    apis: [
      { name: 'SelectFree_ORG', path: '/request/SelectFree_ORG', method: 'GET' },
      { name: 'SelectFreeBoardPage', path: '/request/SelectFreeBoardPage', method: 'POST' },
      { name: 'SelectFreeBoardPageList', path: '/request/SelectFreeBoardPageList', method: 'POST' },
    ],
  },
  {
    id: 'board-news', label: '📋 게시판 — 공지',
    apis: [
      { name: 'SelectNews_ORG', path: '/request/SelectNews_ORG', method: 'GET' },
      { name: 'SelectNewsBoardPage', path: '/request/SelectNewsBoardPage', method: 'POST' },
      { name: 'SelectNewsBoardPageList', path: '/request/SelectNewsBoardPageList', method: 'POST' },
    ],
  },
  {
    id: 'board-qa', label: '📋 게시판 — QA',
    apis: [
      { name: 'SelectQA_ORG', path: '/request/SelectQA_ORG', method: 'GET' },
      { name: 'SelectQABoardPage', path: '/request/SelectQABoardPage', method: 'POST' },
      { name: 'SelectQABoardPageList', path: '/request/SelectQABoardPageList', method: 'POST' },
    ],
  },
  {
    id: 'work-dev', label: '🛠️ 작업실 — 개발자',
    apis: [
      { name: 'SelectDeveloper_ORG', path: '/request/SelectDeveloper_ORG', method: 'GET' },
      { name: 'SelectDeveloperBoardPage', path: '/request/SelectDeveloperBoardPage', method: 'POST' },
      { name: 'SelectDeveloperBoardPageList', path: '/request/SelectDeveloperBoardPageList', method: 'POST' },
      { name: 'DeveloperCategoryList', path: '/request/DeveloperCategoryList', method: 'POST' },
    ],
  },
  {
    id: 'work-note', label: '🛠️ 작업실 — 개발자노트',
    apis: [
      { name: 'SelectDeveloperNote', path: '/request/SelectDeveloperNote', method: 'GET' },
      { name: 'SelectDeveloperNote_ORG', path: '/request/SelectDeveloperNote_ORG', method: 'GET' },
      { name: 'SelectDeveloperNoteBoardPage', path: '/request/SelectDeveloperNoteBoardPage', method: 'POST' },
      { name: 'SelectDeveloperNoteBoardPageList', path: '/request/SelectDeveloperNoteBoardPageList', method: 'POST' },
    ],
  },
  {
    id: 'work-design', label: '🛠️ 작업실 — 디자이너',
    apis: [
      { name: 'SelectDesign_ORG', path: '/request/SelectDesign_ORG', method: 'GET' },
      { name: 'SelectDesignBoardPage', path: '/request/SelectDesignBoardPage', method: 'POST' },
      { name: 'SelectDesignBoardPageList', path: '/request/SelectDesignBoardPageList', method: 'POST' },
      { name: 'DesignCategoryList', path: '/request/DesignCategoryList', method: 'POST' },
    ],
  },
  {
    id: 'work-infra', label: '🛠️ 작업실 — 인프라',
    apis: [
      { name: 'SelectInfra_ORG', path: '/request/SelectInfra_ORG', method: 'GET' },
      { name: 'SelectInfraBoardPage', path: '/request/SelectInfraBoardPage', method: 'POST' },
      { name: 'SelectInfraBoardPageList', path: '/request/SelectInfraBoardPageList', method: 'POST' },
    ],
  },
  {
    id: 'work-other', label: '🛠️ 작업실 — 기타',
    apis: [
      { name: 'SelectModeler_ORG', path: '/request/SelectModeler_ORG', method: 'GET' },
      { name: 'SelectMedia_ORG', path: '/request/SelectMedia_ORG', method: 'GET' },
      { name: 'SelectWork_ORG', path: '/request/SelectWork_ORG', method: 'GET' },
      { name: 'SelectPlan_ORG', path: '/request/SelectPlan_ORG', method: 'GET' },
    ],
  },
  {
    id: 'help-inquery', label: '💬 고객센터 — 문의',
    apis: [
      { name: 'SelectHelpInquery_ORG', path: '/request/SelectHelpInquery_ORG', method: 'GET' },
      { name: 'SelectHelpInqueryBoardPage', path: '/request/SelectHelpInqueryBoardPage', method: 'POST' },
      { name: 'SelectHelpInqueryBoardPageList', path: '/request/SelectHelpInqueryBoardPageList', method: 'POST' },
      { name: 'InqueryCategoryList', path: '/request/InqueryCategoryList', method: 'POST' },
    ],
  },
  {
    id: 'help-bug', label: '🐛 고객센터 — 버그',
    apis: [
      { name: 'SelectHelpBug_ORG', path: '/request/SelectHelpBug_ORG', method: 'GET' },
      { name: 'SelectHelpBugBoardPage', path: '/request/SelectHelpBugBoardPage', method: 'POST' },
      { name: 'SelectHelpBugBoardPageList', path: '/request/SelectHelpBugBoardPageList', method: 'POST' },
      { name: 'BugCategoryList', path: '/request/BugCategoryList', method: 'POST' },
    ],
  },
  {
    id: 'help-suggest', label: '💡 고객센터 — 건의',
    apis: [
      { name: 'SelectHelpSuggestions_ORG', path: '/request/SelectHelpSuggestions_ORG', method: 'GET' },
      { name: 'SelectHelpSuggestionsBoardPage', path: '/request/SelectHelpSuggestionsBoardPage', method: 'POST' },
      { name: 'SelectHelpSuggestionsBoardPageList', path: '/request/SelectHelpSuggestionsBoardPageList', method: 'POST' },
      { name: 'SuggestionsCategoryList', path: '/request/SuggestionsCategoryList', method: 'POST' },
    ],
  },
  {
    id: 'photo', label: '📸 사진첩',
    apis: [
      { name: 'GetAllFeedPhoto_ORG', path: '/request/GetAllFeedPhoto_ORG', method: 'GET' },
      { name: 'GetAllFeedPhotos', path: '/request/GetAllFeedPhotos', method: 'GET' },
      { name: 'GetFeedPhoto_ORG', path: '/request/GetFeedPhoto_ORG', method: 'GET' },
      { name: 'GetDevPhoto_ORG', path: '/request/GetDevPhoto_ORG', method: 'GET' },
      { name: 'GetMdlPhoto_ORG', path: '/request/GetMdlPhoto_ORG', method: 'GET' },
      { name: 'GetDgnPhoto_ORG', path: '/request/GetDgnPhoto_ORG', method: 'GET' },
      { name: 'GetIfaPhoto_ORG', path: '/request/GetIfaPhoto_ORG', method: 'GET' },
      { name: 'GetMediaPhoto_ORG', path: '/request/GetMediaPhoto_ORG', method: 'GET' },
    ],
  },
  {
    id: 'member', label: '👤 회원',
    apis: [
      { name: 'CreateSession', path: '/request/CreateSession', method: 'GET' },
      { name: 'Login', path: '/request/Login', method: 'POST' },
      { name: 'Logout', path: '/request/Logout', method: 'GET' },
      { name: 'Destroy', path: '/request/Destroy', method: 'GET' },
      { name: 'ReadProfile', path: '/request/ReadProfile', method: 'POST' },
    ],
  },
  {
    id: 'schedule', label: '📅 일정/작업',
    apis: [
      { name: 'GetWorkCalendarWBS', path: '/request/GetWorkCalendarWBS', method: 'GET' },
      { name: 'SelectTaskList', path: '/request/SelectTaskList', method: 'POST' },
      { name: 'GetToDoList', path: '/request/GetToDoList', method: 'POST' },
    ],
  },
  {
    id: 'etc', label: '🔗 기타',
    apis: [
      { name: 'rooms', path: '/request/rooms', method: 'GET' },
    ],
  },
  {
    id: 'external', label: '🌐 외부 서비스',
    apis: [
      { name: 'AntsTalk (SSO)', path: 'https://talk.antsnest.co.kr', method: 'GET', external: true },
      { name: '파일서버 (Skynet)', path: 'https://files.skynet.re.kr', method: 'GET', external: true },
    ],
  },
];

const ALL_APIS = API_CATEGORIES.flatMap((c) => c.apis);
const TOTAL_API_COUNT = ALL_APIS.length;

/* ═══════════════════════════════════════════════════════════════
   헬스체크 카테고리 (서버 응답용)
   ═══════════════════════════════════════════════════════════════ */
const HC_CATEGORY_LABELS = {
  core: '🔧 코어',
  home: '🏠 홈 API',
  board: '📋 게시판',
  member: '👤 회원',
  workroom: '🛠️ 작업실',
  external: '🌐 외부 서비스',
};
const HC_CATEGORY_ORDER = ['core', 'home', 'board', 'member', 'workroom', 'external'];

/* ═══════════════════════════════════════════════════════════════
   유틸
   ═══════════════════════════════════════════════════════════════ */
function stateFromHttp(code) {
  if (code >= 200 && code < 300) return 'pass';
  if (code >= 300 && code < 400) return 'warn';
  return 'fail';
}

function stateIcon(state) {
  if (state === 'pass') return '🟢';
  if (state === 'warn') return '🟡';
  if (state === 'fail') return '🔴';
  if (state === 'pending') return '⏳';
  return '⚪';
}

function formatTime(iso) {
  if (!iso) return '-';
  return new Date(iso).toLocaleString('ko-KR', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}

function prettyBody(raw) {
  if (!raw) return '';
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

/* ═══════════════════════════════════════════════════════════════
   단일 API 호출 헬퍼
   ═══════════════════════════════════════════════════════════════ */
async function callApi(api) {
  const start = Date.now();
  try {
    if (api.external) {
      const res = await fetch(`/request/HealthCheckProxy?url=${encodeURIComponent(api.path)}`);
      const json = await res.json();
      return {
        httpStatus: json.httpStatus,
        responseTime: json.responseTime,
        body: json.body || '',
        state: json.httpStatus ? stateFromHttp(json.httpStatus) : 'fail',
      };
    }

    const opts = api.method === 'POST'
      ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }
      : {};

    const res = await fetch(api.path, opts);
    const text = await res.text();
    return {
      httpStatus: res.status,
      responseTime: Date.now() - start,
      body: text.length > 2000 ? text.substring(0, 2000) + '…' : text,
      state: stateFromHttp(res.status),
    };
  } catch (err) {
    return {
      httpStatus: 0,
      responseTime: Date.now() - start,
      body: err.message,
      state: 'fail',
    };
  }
}

/* ═══════════════════════════════════════════════════════════════
   메인 컴포넌트
   ═══════════════════════════════════════════════════════════════ */
function HealthCheck() {
  /* ── 탭 ── */
  const [tab, setTab] = useState('health');

  /* ── 헬스체크 상태 ── */
  const [hcData, setHcData] = useState(null);
  const [hcLoading, setHcLoading] = useState(false);
  const [hcError, setHcError] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const intervalRef = useRef(null);

  /* ── API 테스터 상태 ── */
  const [results, setResults] = useState({});         // { [path]: { httpStatus, responseTime, body, state } }
  const [expanded, setExpanded] = useState({});        // { [path]: bool } — 응답 미리보기 토글
  const [collapsedCats, setCollapsedCats] = useState({});
  const [testingAll, setTestingAll] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });
  const cancelRef = useRef(false);

  /* ── 헬스체크 로직 ── */
  const fetchHealth = useCallback(async () => {
    setHcLoading(true);
    setHcError(null);
    try {
      const res = await fetch('/request/HealthCheck');
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setHcData(await res.json());
    } catch (err) {
      setHcError(err.message);
    } finally {
      setHcLoading(false);
    }
  }, []);

  useEffect(() => { fetchHealth(); }, [fetchHealth]);

  useEffect(() => {
    if (autoRefresh) intervalRef.current = setInterval(fetchHealth, 30000);
    else if (intervalRef.current) clearInterval(intervalRef.current);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [autoRefresh, fetchHealth]);

  /* ── API 테스터 로직 ── */
  const testOne = useCallback(async (api) => {
    setResults((prev) => ({ ...prev, [api.path]: { state: 'pending', httpStatus: 0, responseTime: 0, body: '' } }));
    const result = await callApi(api);
    setResults((prev) => ({ ...prev, [api.path]: result }));
  }, []);

  const testAll = useCallback(async () => {
    cancelRef.current = false;
    setTestingAll(true);
    setProgress({ current: 0, total: TOTAL_API_COUNT });

    for (let i = 0; i < ALL_APIS.length; i++) {
      if (cancelRef.current) break;
      const api = ALL_APIS[i];
      setResults((prev) => ({ ...prev, [api.path]: { state: 'pending', httpStatus: 0, responseTime: 0, body: '' } }));
      const result = await callApi(api);
      setResults((prev) => ({ ...prev, [api.path]: result }));
      setProgress({ current: i + 1, total: TOTAL_API_COUNT });
    }

    setTestingAll(false);
  }, []);

  const stopAll = () => { cancelRef.current = true; };
  const clearResults = () => { setResults({}); setExpanded({}); };

  const togglePreview = (path) => setExpanded((p) => ({ ...p, [path]: !p[path] }));
  const toggleCat = (id) => setCollapsedCats((p) => ({ ...p, [id]: !p[id] }));

  /* ── 헬스체크 통계 ── */
  const hcGrouped = {};
  if (hcData && hcData.checks) {
    hcData.checks.forEach((c) => {
      if (!hcGrouped[c.category]) hcGrouped[c.category] = [];
      hcGrouped[c.category].push(c);
    });
  }
  const hcStats = { avg: 0, max: 0, total: 0, pass: 0, fail: 0 };
  if (hcData && hcData.checks && hcData.checks.length) {
    const t = hcData.checks.map((c) => c.responseTime);
    hcStats.total = hcData.checks.length;
    hcStats.pass = hcData.checks.filter((c) => c.status === 'pass').length;
    hcStats.fail = hcData.checks.filter((c) => c.status === 'fail').length;
    hcStats.avg = Math.round(t.reduce((a, b) => a + b, 0) / t.length);
    hcStats.max = Math.max(...t);
  }

  /* ── API 테스터 통계 ── */
  const tested = Object.keys(results).filter((k) => results[k].state !== 'pending').length;
  const passCount = Object.values(results).filter((r) => r.state === 'pass').length;
  const warnCount = Object.values(results).filter((r) => r.state === 'warn').length;
  const failCount = Object.values(results).filter((r) => r.state === 'fail').length;
  const avgTime = tested > 0
    ? Math.round(Object.values(results).filter((r) => r.state !== 'pending').reduce((s, r) => s + r.responseTime, 0) / tested)
    : 0;
  const maxTime = tested > 0
    ? Math.max(...Object.values(results).filter((r) => r.state !== 'pending').map((r) => r.responseTime))
    : 0;

  /* ═══════════ 렌더 ═══════════ */
  return (
    <div className="hc-container">

      {/* ── 탭 네비게이션 ── */}
      <div className="hc-tabs">
        <button className={`hc-tabs__btn ${tab === 'health' ? 'hc-tabs__btn--active' : ''}`} onClick={() => setTab('health')}>
          📊 헬스체크
        </button>
        <button className={`hc-tabs__btn ${tab === 'tester' ? 'hc-tabs__btn--active' : ''}`} onClick={() => setTab('tester')}>
          🧪 API 테스터
        </button>
      </div>

      {/* ══════════════════════════════════════════
          탭 1: 헬스체크
          ══════════════════════════════════════════ */}
      {tab === 'health' && (
        <>
          {/* 배너 */}
          <div className={`hc-banner ${hcData ? (hcData.overall === 'pass' ? 'hc-banner--pass' : 'hc-banner--fail') : 'hc-banner--loading'}`}>
            <div className="hc-banner__status">
              <span className="hc-banner__icon">
                {hcLoading && !hcData ? '⏳' : hcData ? (hcData.overall === 'pass' ? '✅' : '❌') : '⚠️'}
              </span>
              <h1 className="hc-banner__title">
                {hcLoading && !hcData ? '체크 중...' : hcData ? (hcData.overall === 'pass' ? '모든 서비스 정상' : '장애 감지') : '상태 확인 실패'}
              </h1>
            </div>
            {hcData && (
              <p className="hc-banner__subtitle">
                {hcStats.pass}/{hcStats.total} 통과 · 마지막 체크: {formatTime(hcData.timestamp)}
              </p>
            )}
            {hcError && <p className="hc-banner__error">오류: {hcError}</p>}
          </div>

          {/* 컨트롤 */}
          <div className="hc-controls">
            <button className="hc-btn" onClick={fetchHealth} disabled={hcLoading}>
              {hcLoading ? '체크 중...' : '🔄 지금 체크'}
            </button>
            <label className="hc-toggle">
              <input type="checkbox" checked={autoRefresh} onChange={(e) => setAutoRefresh(e.target.checked)} />
              <span className="hc-toggle__slider"></span>
              <span className="hc-toggle__label">자동 갱신 (30초)</span>
            </label>
          </div>

          {/* 카테고리별 카드 */}
          {HC_CATEGORY_ORDER.map((cat) => {
            const items = hcGrouped[cat];
            if (!items) return null;
            return (
              <div className="hc-category" key={cat}>
                <h2 className="hc-category__title">{HC_CATEGORY_LABELS[cat] || cat}</h2>
                <div className="hc-grid">
                  {items.map((check, i) => (
                    <div className={`hc-card ${check.status === 'pass' ? 'hc-card--pass' : 'hc-card--fail'}`} key={i}>
                      <div className="hc-card__header">
                        <span className="hc-card__icon">{check.status === 'pass' ? '🟢' : '🔴'}</span>
                        <span className="hc-card__name">{check.name}</span>
                      </div>
                      <div className="hc-card__time">{check.responseTime}ms</div>
                      {check.error && <div className="hc-card__error">{check.error}</div>}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

          {/* 통계 */}
          {hcData && hcData.checks && hcData.checks.length > 0 && (
            <div className="hc-stats">
              <div className="hc-stats__item">
                <span className="hc-stats__label">평균 응답</span>
                <span className="hc-stats__value">{hcStats.avg}ms</span>
              </div>
              <div className="hc-stats__item">
                <span className="hc-stats__label">최대 응답</span>
                <span className="hc-stats__value">{hcStats.max}ms</span>
              </div>
              <div className="hc-stats__item">
                <span className="hc-stats__label">통과</span>
                <span className="hc-stats__value hc-stats__value--pass">{hcStats.pass}</span>
              </div>
              <div className="hc-stats__item">
                <span className="hc-stats__label">실패</span>
                <span className="hc-stats__value hc-stats__value--fail">{hcStats.fail}</span>
              </div>
            </div>
          )}
        </>
      )}

      {/* ══════════════════════════════════════════
          탭 2: API 테스터
          ══════════════════════════════════════════ */}
      {tab === 'tester' && (
        <>
          {/* 상단 요약 */}
          <div className="at-summary">
            <div className="at-summary__left">
              <span className="at-summary__total">전체 {TOTAL_API_COUNT}개 API</span>
              {tested > 0 && (
                <span className="at-summary__counts">
                  테스트 {tested}개 — {stateIcon('pass')} {passCount}
                  {warnCount > 0 && <> · {stateIcon('warn')} {warnCount}</>}
                  {failCount > 0 && <> · {stateIcon('fail')} {failCount}</>}
                </span>
              )}
            </div>
            {tested > 0 && (
              <div className="at-summary__right">
                <span>평균 {avgTime}ms</span>
                <span className="at-summary__sep">·</span>
                <span>최대 {maxTime}ms</span>
              </div>
            )}
          </div>

          {/* 컨트롤 */}
          <div className="hc-controls">
            {!testingAll ? (
              <button className="hc-btn" onClick={testAll}>🚀 전체 테스트</button>
            ) : (
              <button className="hc-btn hc-btn--danger" onClick={stopAll}>⏹ 중지</button>
            )}
            <button className="hc-btn hc-btn--outline" onClick={clearResults} disabled={testingAll}>🗑 결과 초기화</button>

            {testingAll && (
              <div className="at-progress">
                <div className="at-progress__bar">
                  <div
                    className="at-progress__fill"
                    style={{ width: `${progress.total ? (progress.current / progress.total) * 100 : 0}%` }}
                  />
                </div>
                <span className="at-progress__text">{progress.current}/{progress.total}</span>
              </div>
            )}
          </div>

          {/* 카테고리별 API 카드 */}
          {API_CATEGORIES.map((cat) => {
            const isCollapsed = collapsedCats[cat.id];
            const catResults = cat.apis.map((a) => results[a.path]).filter(Boolean);
            const catPass = catResults.filter((r) => r.state === 'pass').length;
            const catFail = catResults.filter((r) => r.state === 'fail' || r.state === 'warn').length;

            return (
              <div className="at-category" key={cat.id}>
                <div className="at-category__header" onClick={() => toggleCat(cat.id)}>
                  <span className="at-category__arrow">{isCollapsed ? '▶' : '▼'}</span>
                  <h2 className="at-category__title">{cat.label}</h2>
                  <span className="at-category__badge">{cat.apis.length}개</span>
                  {catResults.length > 0 && (
                    <span className="at-category__score">
                      {catPass > 0 && <span className="at-category__score--pass">{stateIcon('pass')} {catPass}</span>}
                      {catFail > 0 && <span className="at-category__score--fail">{stateIcon('fail')} {catFail}</span>}
                    </span>
                  )}
                </div>

                {!isCollapsed && (
                  <div className="at-grid">
                    {cat.apis.map((api) => {
                      const r = results[api.path];
                      const st = r ? r.state : 'idle';
                      const isExpanded = expanded[api.path];

                      return (
                        <div className={`at-card at-card--${st}`} key={api.path}>
                          {/* 카드 헤더 */}
                          <div className="at-card__header">
                            <span className="at-card__status">{stateIcon(st)}</span>
                            <span className="at-card__name">{api.name}</span>
                            <span className={`at-card__method at-card__method--${api.method.toLowerCase()}`}>
                              {api.method}
                            </span>
                          </div>

                          {/* 결과 */}
                          {r && r.state !== 'pending' && (
                            <div className="at-card__result">
                              <span className={`at-card__http at-card__http--${st}`}>
                                {r.httpStatus || 'ERR'}
                              </span>
                              <span className="at-card__time">{r.responseTime}ms</span>
                              <button className="at-card__preview-btn" onClick={() => togglePreview(api.path)}>
                                {isExpanded ? '접기 ▲' : '응답 ▼'}
                              </button>
                            </div>
                          )}

                          {r && r.state === 'pending' && (
                            <div className="at-card__result">
                              <span className="at-card__pending">테스트 중...</span>
                            </div>
                          )}

                          {/* 응답 미리보기 */}
                          {isExpanded && r && r.body && (
                            <pre className="at-card__body">{prettyBody(r.body)}</pre>
                          )}

                          {/* 테스트 버튼 */}
                          <button
                            className="at-card__test-btn"
                            onClick={() => testOne(api)}
                            disabled={testingAll || (r && r.state === 'pending')}
                          >
                            {r && r.state === 'pending' ? '⏳' : '▶ 테스트'}
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

export default HealthCheck;
